import { cn, getStatusColor, getPriorityColor } from '../../lib/utils';

export function StatusBadge({ status, type = 'status' }) {
  const colorClass = type === 'priority' ? getPriorityColor(status) : getStatusColor(status);
  
  return (
    <span className={cn(
      "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border capitalize",
      colorClass
    )}>
      {status}
    </span>
  );
}
